import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useAuth } from "../../../context/AuthProvider";
import { Link } from "react-router-dom";
import Logo from "../../Misc/Logo";
import DropActionBtn from "../../../components/Forms/Controls/DropActionBtn";
import { useBranding } from "../../../context/BrandingProvider";
import { fetchTotpCode, sendVerifyTotpCode } from "@api/me/index.jsx";
import { useNotification } from "@context/NotificationProvider";
import DialogModal from "@components/Misc/DialogModal/index.jsx";
import ActionBtn from "@components/Forms/Controls/ActionBtn/index.jsx";
import TextInput from "@components/Forms/Controls/TextInput/index.jsx";
import {
  createUserApiKey,
  getUserApiKeys,
  revokeUserApiKey,
} from "@api/api_key_management";
import ApiKeyManagementModal from "@components/Features/Admin/ApiKeyManagementModal";

export default function AppHeaderView() {
  const { user, signOut, isShowActivateMfa } = useAuth();
  const { branding } = useBranding();
  const aController = new AbortController();
  const [qrCode, setQrCode] = useState();
  const [secretCode, setSecretCode] = useState();
  const [code, setCode] = useState();
  const [loading, setLoading] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [showApiKeysModal, setShowApiKeysModal] = useState(false);
  const { setNotification } = useNotification();

  const getTotpCode = async () => {
    try {
      const response = await fetchTotpCode({ aController });

      if (response?.error) throw new Error(response.error.message);

      setQrCode(response.uri);
      setSecretCode(response.secret_code);
      setIsShowModal(true);
    } catch (error) {
      setNotification({
        message: error?.message ?? "Oops! something went wrong.",
        iconName: "ban",
        hex: "var(--danger-1)",
      });
    }
  };
  const submitCode = async () => {
    try {
      setLoading(true);
      const response = await sendVerifyTotpCode({ aController, code });

      if (response?.error) throw new Error(response.error.message);

      setQrCode(null);
      setSecretCode(null);
      setIsShowModal(false);
      signOut();
    } catch (error) {
      setNotification({
        message: error?.message ?? "Oops! something went wrong.",
        iconName: "ban",
        hex: "var(--danger-1)",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <header className="app-header">
      <div className={`app-header-left ${branding.className}`}>
        <Link to="/">
          <Logo branding={branding} />
        </Link>
        <span className="app-name">Decoder Dashboard</span>
      </div>
      <div className="app-header-right">
        <DropActionBtn
          loading={false}
          // callback={() => console.log("callback")}
          icon="user circle"
          isInverted={true}
          isBase={true}
          label={
            user?.signInUserSession?.idToken?.payload?.name ?? user?.username
          }
          items={[
            ...(isShowActivateMfa
              ? [
                  {
                    value: "activate_totp",
                    label: "Enable MFA",
                    callback: () => getTotpCode(),
                  },
                ]
              : []),
            {
              value: "manage_api_keys",
              label: "Manage API Keys",
              callback: () => setShowApiKeysModal(true),
            },
            {
              value: "sign_out",
              label: "Sign Out",
              callback: () => signOut(),
            },
          ]}
        />
      </div>
      <DialogModal isOpen={isShowModal} setOpen={setIsShowModal}>
        <div style={{ maxWidth: 400 }}>
          <h2>Secure Your Account</h2>
          <br />
          <div className="instruction">
            <h3 className="instruction__header" style={{ textAlign: "left" }}>
              Scan The QR Code below using preferred authenticator app and then
              enter the provided one-time code below.
            </h3>
            <div
              style={{ textAlign: "center", marginTop: 10, marginBottom: 10 }}
            >
              <QRCodeSVG value={qrCode} />
            </div>
            <p style={{ fontSize: 12, marginBottom: 10 }}>{secretCode}</p>
            <TextInput
              label={"Enter Code"}
              onChange={(e) => setCode(e.target.value)}
              name="code"
              value={code}
              type="text"
              isSecret={false}
              isRequired={true}
            />
          </div>

          <ActionBtn
            loading={loading}
            callback={() => submitCode()}
            isFluid={true}
            label={"Submit and Re-login"}
            isDisabled={false}
          />
        </div>
      </DialogModal>
      <ApiKeyManagementModal
        isOpen={showApiKeysModal}
        setOpen={setShowApiKeysModal}
        fetchApiKeys={getUserApiKeys}
        createApiKey={createUserApiKey}
        revokeApiKey={revokeUserApiKey}
      />
    </header>
  );
}
